import { g as re, c as m } from "./index-DhidOF4D.mjs";
import { p as k } from "./index-xuotMAFm.mjs";
import { s as ne } from "./index-CzJutop_.mjs";
var z = { exports: {} };
function ie(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return '"[Circular]"';
  }
}
var ae = oe;
function oe(e, t, r) {
  var i = r && r.stringify || ie, a = 1;
  if (typeof e == "object" && e !== null) {
    var o = t.length + a;
    if (o === 1) return e;
    var s = new Array(o);
    s[0] = i(e);
    for (var l = 1; l < o; l++)
      s[l] = i(t[l]);
    return s.join(" ");
  }
  if (typeof e != "string")
    return e;
  var d = t.length;
  if (d === 0) return e;
  for (var n = "", c = 1 - a, f = -1, b = e && e.length || 0, u = 0; u < b; ) {
    if (e.charCodeAt(u) === 37 && u + 1 < b) {
      switch (f = f > -1 ? f : 0, e.charCodeAt(u + 1)) {
        case 100:
        case 102:
          if (c >= d || t[c] == null) break;
          f < u && (n += e.slice(f, u)), n += Number(t[c]), f = u + 2, u++;
          break;
        case 105:
          if (c >= d || t[c] == null) break;
          f < u && (n += e.slice(f, u)), n += Math.floor(Number(t[c])), f = u + 2, u++;
          break;
        case 79:
        case 111:
        case 106:
          if (c >= d || t[c] === void 0) break;
          f < u && (n += e.slice(f, u));
          var w = typeof t[c];
          if (w === "string") {
            n += "'" + t[c] + "'", f = u + 2, u++;
            break;
          }
          if (w === "function") {
            n += t[c].name || "<anonymous>", f = u + 2, u++;
            break;
          }
          n += i(t[c]), f = u + 2, u++;
          break;
        case 115:
          if (c >= d)
            break;
          f < u && (n += e.slice(f, u)), n += String(t[c]), f = u + 2, u++;
          break;
        case 37:
          f < u && (n += e.slice(f, u)), n += "%", f = u + 2, u++, c--;
          break;
      }
      ++c;
    }
    ++u;
  }
  return f === -1 ? e : (f < b && (n += e.slice(f)), n);
}
const H = ae;
z.exports = _;
const L = we().console || {}, se = {
  mapHttpRequest: P,
  mapHttpResponse: P,
  wrapRequestSerializer: M,
  wrapResponseSerializer: M,
  wrapErrorSerializer: M,
  req: P,
  res: P,
  err: U,
  errWithCause: U
};
function g(e, t) {
  return e === "silent" ? 1 / 0 : t.levels.values[e];
}
const $ = Symbol("pino.logFuncs"), q = Symbol("pino.hierarchy"), le = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function K(e, t) {
  const r = {
    logger: t,
    parent: e[q]
  };
  t[q] = r;
}
function ce(e, t, r) {
  const i = {};
  t.forEach((a) => {
    i[a] = r[a] ? r[a] : L[a] || L[le[a] || "log"] || O;
  }), e[$] = i;
}
function ue(e, t) {
  return Array.isArray(e) ? e.filter(function(i) {
    return i !== "!stdSerializers.err";
  }) : e === !0 ? Object.keys(t) : !1;
}
function _(e) {
  e = e || {}, e.browser = e.browser || {};
  const t = e.browser.transmit;
  if (t && typeof t.send != "function")
    throw Error("pino: transmit option must have a send function");
  const r = e.browser.write || L;
  e.browser.write && (e.browser.asObject = !0);
  const i = e.serializers || {}, a = ue(e.browser.serialize, i);
  let o = e.browser.serialize;
  Array.isArray(e.browser.serialize) && e.browser.serialize.indexOf("!stdSerializers.err") > -1 && (o = !1);
  const s = Object.keys(e.customLevels || {}), l = ["error", "fatal", "warn", "info", "debug", "trace"].concat(s);
  typeof r == "function" && l.forEach(function(v) {
    r[v] = r;
  }), (e.enabled === !1 || e.browser.disabled) && (e.level = "silent");
  const d = e.level || "info", n = Object.create(r);
  n.log || (n.log = O), ce(n, l, r), K({}, n), Object.defineProperty(n, "levelVal", {
    get: f
  }), Object.defineProperty(n, "level", {
    get: b,
    set: u
  });
  const c = {
    transmit: t,
    serialize: a,
    asObject: e.browser.asObject,
    formatters: e.browser.formatters,
    levels: l,
    timestamp: ge(e),
    messageKey: e.messageKey || "msg",
    onChild: e.onChild || O
  };
  n.levels = fe(e), n.level = d, n.setMaxListeners = n.getMaxListeners = n.emit = n.addListener = n.on = n.prependListener = n.once = n.prependOnceListener = n.removeListener = n.removeAllListeners = n.listeners = n.listenerCount = n.eventNames = n.write = n.flush = O, n.serializers = i, n._serialize = a, n._stdErrSerialize = o, n.child = function(...v) {
    return w.call(this, c, ...v);
  }, t && (n._logEvent = D());
  function f() {
    return g(this.level, this);
  }
  function b() {
    return this._level;
  }
  function u(v) {
    if (v !== "silent" && !this.levels.values[v])
      throw Error("unknown level " + v);
    this._level = v, y(this, c, n, "error"), y(this, c, n, "fatal"), y(this, c, n, "warn"), y(this, c, n, "info"), y(this, c, n, "debug"), y(this, c, n, "trace"), s.forEach((h) => {
      y(this, c, n, h);
    });
  }
  function w(v, h, p) {
    if (!h)
      throw new Error("missing bindings for child Pino");
    p = p || {}, a && h.serializers && (p.serializers = h.serializers);
    const G = p.serializers;
    if (a && G) {
      var C = Object.assign({}, i, G), W = e.browser.serialize === !0 ? Object.keys(C) : a;
      delete h.serializers, N([h], W, C, this._stdErrSerialize);
    }
    function J(E) {
      this._childLevel = (E._childLevel | 0) + 1, this.bindings = h, C && (this.serializers = C, this._serialize = W), t && (this._logEvent = D(
        [].concat(E._logEvent.bindings, h)
      ));
    }
    J.prototype = this;
    const j = new J(this);
    return K(this, j), j.child = function(...E) {
      return w.call(this, v, ...E);
    }, j.level = p.level || this.level, v.onChild(j), j;
  }
  return n;
}
function fe(e) {
  const t = e.customLevels || {}, r = Object.assign({}, _.levels.values, t), i = Object.assign({}, _.levels.labels, de(t));
  return {
    values: r,
    labels: i
  };
}
function de(e) {
  const t = {};
  return Object.keys(e).forEach(function(r) {
    t[e[r]] = r;
  }), t;
}
_.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
_.stdSerializers = se;
_.stdTimeFunctions = Object.assign({}, { nullTime: Y, epochTime: Q, unixTime: ye, isoTime: Oe });
function me(e) {
  const t = [];
  e.bindings && t.push(e.bindings);
  let r = e[q];
  for (; r.parent; )
    r = r.parent, r.logger.bindings && t.push(r.logger.bindings);
  return t.reverse();
}
function y(e, t, r, i) {
  if (Object.defineProperty(e, i, {
    value: g(e.level, r) > g(i, r) ? O : r[$][i],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), e[i] === O) {
    if (!t.transmit) return;
    const o = t.transmit.level || e.level, s = g(o, r);
    if (g(i, r) < s) return;
  }
  e[i] = ve(e, t, r, i);
  const a = me(e);
  a.length !== 0 && (e[i] = be(a, e[i]));
}
function be(e, t) {
  return function() {
    return t.apply(this, [...e, ...arguments]);
  };
}
function ve(e, t, r, i) {
  return /* @__PURE__ */ function(a) {
    return function() {
      const s = t.timestamp(), l = new Array(arguments.length), d = Object.getPrototypeOf && Object.getPrototypeOf(this) === L ? L : this;
      for (var n = 0; n < l.length; n++) l[n] = arguments[n];
      var c = !1;
      if (t.serialize && (N(l, this._serialize, this.serializers, this._stdErrSerialize), c = !0), t.asObject || t.formatters ? a.call(d, he(this, i, l, s, t)) : a.apply(d, l), t.transmit) {
        const f = t.transmit.level || e._level, b = g(f, r), u = g(i, r);
        if (u < b) return;
        _e(this, {
          ts: s,
          methodLevel: i,
          methodValue: u,
          transmitLevel: f,
          transmitValue: r.levels.values[t.transmit.level || e._level],
          send: t.transmit.send,
          val: g(e._level, r)
        }, l, c);
      }
    };
  }(e[$][i]);
}
function he(e, t, r, i, a) {
  const {
    level: o,
    log: s = (b) => b
  } = a.formatters || {}, l = r.slice();
  let d = l[0];
  const n = {};
  if (i && (n.time = i), o) {
    const b = o(t, e.levels.values[t]);
    Object.assign(n, b);
  } else
    n.level = e.levels.values[t];
  let c = (e._childLevel | 0) + 1;
  if (c < 1 && (c = 1), d !== null && typeof d == "object") {
    for (; c-- && typeof l[0] == "object"; )
      Object.assign(n, l.shift());
    d = l.length ? H(l.shift(), l) : void 0;
  } else typeof d == "string" && (d = H(l.shift(), l));
  return d !== void 0 && (n[a.messageKey] = d), s(n);
}
function N(e, t, r, i) {
  for (const a in e)
    if (i && e[a] instanceof Error)
      e[a] = _.stdSerializers.err(e[a]);
    else if (typeof e[a] == "object" && !Array.isArray(e[a]) && t)
      for (const o in e[a])
        t.indexOf(o) > -1 && o in r && (e[a][o] = r[o](e[a][o]));
}
function _e(e, t, r, i = !1) {
  const a = t.send, o = t.ts, s = t.methodLevel, l = t.methodValue, d = t.val, n = e._logEvent.bindings;
  i || N(
    r,
    e._serialize || Object.keys(e.serializers),
    e.serializers,
    e._stdErrSerialize === void 0 ? !0 : e._stdErrSerialize
  ), e._logEvent.ts = o, e._logEvent.messages = r.filter(function(c) {
    return n.indexOf(c) === -1;
  }), e._logEvent.level.label = s, e._logEvent.level.value = l, a(s, e._logEvent, d), e._logEvent = D(n);
}
function D(e) {
  return {
    ts: 0,
    messages: [],
    bindings: e || [],
    level: { label: "", value: 0 }
  };
}
function U(e) {
  const t = {
    type: e.constructor.name,
    msg: e.message,
    stack: e.stack
  };
  for (const r in e)
    t[r] === void 0 && (t[r] = e[r]);
  return t;
}
function ge(e) {
  return typeof e.timestamp == "function" ? e.timestamp : e.timestamp === !1 ? Y : Q;
}
function P() {
  return {};
}
function M(e) {
  return e;
}
function O() {
}
function Y() {
  return !1;
}
function Q() {
  return Date.now();
}
function ye() {
  return Math.round(Date.now() / 1e3);
}
function Oe() {
  return new Date(Date.now()).toISOString();
}
function we() {
  function e(t) {
    return typeof t < "u" && t;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return e(self) || e(window) || e(this) || {};
  }
}
z.exports.default = _;
z.exports.pino = _;
var ee = z.exports;
const Ne = /* @__PURE__ */ re(ee);
var pe = {}, T = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.GlobalContextStorageProvider = void 0;
  const t = Symbol.for("aws.lambda.runtime.context");
  e.GlobalContextStorageProvider = {
    getContext: () => m[t],
    setContext: (r) => m[t] = r,
    updateContext: (r) => {
      const i = e.GlobalContextStorageProvider.getContext();
      m[t] = {
        ...i,
        ...r
      };
    }
  };
})(T);
var F = {}, V = {}, R = {}, S = {}, je = m && m.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(S, "__esModule", { value: !0 });
S.formatLevel = void 0;
const Le = je(ee), Se = (e) => {
  var t;
  return typeof e == "string" ? e.toLocaleUpperCase() : typeof e == "number" ? (t = Le.default.levels.labels[e]) === null || t === void 0 ? void 0 : t.toLocaleUpperCase() : e;
};
S.formatLevel = Se;
Object.defineProperty(R, "__esModule", { value: !0 });
R.CloudwatchLogFormatter = void 0;
const Ce = S;
class Ee {
  format(t) {
    const { awsRequestId: r, level: i, msg: a } = t, o = (/* @__PURE__ */ new Date()).toISOString(), s = Ce.formatLevel(i);
    return `${o}${r ? `	${r}` : ""}	${s}	${a}	${JSON.stringify(t)}`;
  }
}
R.CloudwatchLogFormatter = Ee;
var x = {};
Object.defineProperty(x, "__esModule", { value: !0 });
x.PinoLogFormatter = void 0;
class Pe {
  format(t) {
    return JSON.stringify(t);
  }
}
x.PinoLogFormatter = Pe;
var A = {};
Object.defineProperty(A, "__esModule", { value: !0 });
A.StructuredLogFormatter = void 0;
const ze = S;
class Te {
  format({ awsRequestId: t, level: r, ...i }) {
    return JSON.stringify({
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      level: ze.formatLevel(r),
      requestId: t,
      message: i
    });
  }
}
A.StructuredLogFormatter = Te;
(function(e) {
  var t = m && m.__createBinding || (Object.create ? function(i, a, o, s) {
    s === void 0 && (s = o), Object.defineProperty(i, s, { enumerable: !0, get: function() {
      return a[o];
    } });
  } : function(i, a, o, s) {
    s === void 0 && (s = o), i[s] = a[o];
  }), r = m && m.__exportStar || function(i, a) {
    for (var o in i) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && t(a, i, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(R, e), r(x, e), r(A, e);
})(V);
Object.defineProperty(F, "__esModule", { value: !0 });
F.pinoLambdaDestination = void 0;
const Fe = ne, Re = T, xe = V, Ae = (e = {}) => new Fe.Writable({
  defaultEncoding: "utf8",
  write(r, i, a) {
    const o = e.storageProvider || Re.GlobalContextStorageProvider, s = e.formatter || new xe.CloudwatchLogFormatter(), l = JSON.parse(r), d = o.getContext() || {};
    let n = s.format({ ...d, ...l });
    n = n.replace(/\n/, "\r"), n += `
`, e.streamWriter ? e.streamWriter(n) : k.stdout.write(n), a();
  }
});
F.pinoLambdaDestination = Ae;
var I = {};
Object.defineProperty(I, "__esModule", { value: !0 });
I.lambdaRequestTracker = void 0;
const Ie = T, X = "_X_AMZN_TRACE_ID", B = "x-correlation-", Z = `${B}id`, Me = `${B}trace-id`, ke = (e = {}) => (t, r) => {
  var i;
  const a = {
    awsRequestId: r.awsRequestId
  }, o = (i = t.requestContext) === null || i === void 0 ? void 0 : i.requestId;
  if (o && (a.apiRequestId = o), t.headers)
    for (const [l, d] of Object.entries(t.headers))
      l.toLowerCase().startsWith(B) && (a[l] = d);
  if (k.env[X] && (a[Me] = k.env[X]), a[Z] || (a[Z] = r.awsRequestId), e.requestMixin) {
    const l = e.requestMixin(t, r);
    for (const d in l)
      a[d] = l[d];
  }
  const s = e.storageProvider || Ie.GlobalContextStorageProvider;
  s && s.setContext(a);
};
I.lambdaRequestTracker = ke;
var te = {};
Object.defineProperty(te, "__esModule", { value: !0 });
(function(e) {
  var t = m && m.__createBinding || (Object.create ? function(i, a, o, s) {
    s === void 0 && (s = o), Object.defineProperty(i, s, { enumerable: !0, get: function() {
      return a[o];
    } });
  } : function(i, a, o, s) {
    s === void 0 && (s = o), i[s] = a[o];
  }), r = m && m.__exportStar || function(i, a) {
    for (var o in i) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && t(a, i, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(T, e), r(F, e), r(V, e), r(I, e), r(te, e);
})(pe);
export {
  pe as d,
  Ne as p
};
//# sourceMappingURL=index-FzzLJwwa.mjs.map
